import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, of, tap } from 'rxjs';
import { CurrencyMap } from '../types';

const CURRENCY_API_KEY: string = 'fca_live_V0JEDWsDNmed3pVc8WAvfjnqvqF3KX421IUJdSpt';

@Injectable({
    providedIn: 'root',
})
export class CurrencyService {
    constructor(private http: HttpClient) {}

    getCurrencyMap(): Observable<{ data: CurrencyMap }> {
        return this.http
            .get<{ data: CurrencyMap }>('https://api.freecurrencyapi.com/v1/latest', {
                headers: {
                    apiKey: this.getCurrencyApiKey(),
                },
                params: {
                    base_currency: 'CNY',
                    currencies: 'USD,AUD,CNY',
                },
            })
            .pipe(
                tap((res: { data: CurrencyMap }) => {
                    this.setCurrencyMapToLocalStorage(res);
                })
            )
            .pipe(
                catchError(() => {
                    return of({ data: this.getCurrencyMapFromLocalStorage() });
                })
            );
    }

    getCurrencyApiKey(): string {
        return document?.querySelector('meta[name="CURRENCY_API_KEY"]')?.getAttribute('content') ?? CURRENCY_API_KEY;
    }

    getCurrencyMapFromLocalStorage(): CurrencyMap {
        const currencyMap = localStorage.getItem('__currencyMap');
        return currencyMap
            ? JSON.parse(currencyMap)
            : {
                  USD: 1,
                  AUD: 1,
                  CNY: 1,
              };
    }

    setCurrencyMapToLocalStorage(res: { data: CurrencyMap }): void {
        if (res && res.data) {
            localStorage.setItem('__currencyMap', JSON.stringify(res.data));
        }
    }
}
